import Logo from './Logo';

export default function LoadingScreen({ ...other }) {
  return (
    <div
      className="h-full flex flex-col items-center justify-center text-center bg-gray-50 dark:bg-[#1A1D21]"
      {...other}
    >
      <div className="animate-in fade-in zoom-in duration-500">
        <Logo />
      </div>

      <div className="w-[30%] mt-4 h-1 rounded-full bg-gray-200 dark:bg-[#383838] overflow-hidden">
        <div className="h-full w-2/3 rounded-full bg-[#7C3AED] animate-[loading_1.5s_ease-in-out_infinite]" />
      </div>

      <p className="mt-4 text-xs text-gray-400 dark:text-[#ABABAD] tracking-wide">
        Carregando...
      </p>

      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(50%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </div>
  );
}
